<template>
  <div class="show-user fl">
    <div
      class="user ccui-clearfix"
      :style="
        auditTypeFlag != '1' ? 'margin-bottom: 10px' : 'margin-bottom: 0px'
      "
    >
      <div class="fl">
        <template v-if="loginInfo.mobile">
          <div>
            <img :src="headLogo" class="fl" :class="logoClass" />
            <div class="user-type-welcome ell" :title="loginInfo.mobile">
              {{ loginInfo.mobile }}
            </div>
            <!-- v-if="!languagezh_cn" class="Exit-EN" -->
            <div>
              <div v-if="languagezh_cn" class="user-type-log-out">
                <el-link
                  :underline="false"
                  type="info"
                  class="fr view-all"
                  @click="goTo"
                  :class="[languagezh_cn ? '' : 'font-en']"
                >
                  <!-- 业务协同待办 -->
                  {{ $t("page.content.businessCoordinationToBeDone") }}
                  <span style="color:red;margin-left:5px" v-if="todoTotal">{{
                    todoTotal
                  }}</span></el-link
                >
                <span @click="handleExit" class="edit-exit">{{
                  $t("page.content.Exit")
                }}</span>
              </div>
              <div v-else class="user-type-log-out-en">
                <el-link
                  :underline="false"
                  type="info"
                  class="fr view-all"
                  @click="goTo"
                >
                  <!-- 业务协同待办 -->
                  {{ $t("page.content.businessCoordinationToBeDone") }}
                  <span style="color:red;margin-left:5px" v-if="todoTotal">{{
                    todoTotal
                  }}</span></el-link
                >
                <span @click="handleExit" class="edit-exit">{{
                  $t("page.content.Exit")
                }}</span>
              </div>
            </div>
            <!--审批进度隐藏-->
            <!-- <div v-if="false"> -->
            <div v-if="auditTypeFlag == '1'">
              <!-- 中文版 -->
              <div v-if="languagezh_cn" class="container-text">
                <span
                  class="tip"
                  v-if="
                    auditStatusFlag == '1' ||
                      auditStatusFlag == '2' ||
                      auditStatusFlag == '0' ||
                      auditStatusFlag == '4'
                  "
                  >{{ $t("page.retrievePassword.confirmHint") + "：" }}</span
                >
                <div class="container">
                  <div class="notification">
                    <span v-if="auditStatusFlag == '1'">
                      {{
                        languagezh_cn
                          ? "您的注册申请正在由" +
                            puCompanyName +
                            "审批中，请耐心等待！"
                          : " Your registration application is currently being approved by " +
                            puCompanyName +
                            " Please be patient!"
                      }}
                    </span>
                    <span
                      v-if="auditStatusFlag == '4' || auditStatusFlag == '0'"
                      >{{ $t("page.retrievePassword.confirmTitle8") }}</span
                    >
                    <span v-if="auditStatusFlag == '2'">{{
                      $t("page.retrievePassword.confirmTitle9")
                    }}</span>
                  </div>
                </div>
                <div class="btn">
                  <span
                    class="withdraw-btn"
                    v-if="auditStatusFlag == '1'"
                    @click="withdraw"
                  >
                    {{
                      languagezh_cn
                        ? "撤回注册申请"
                        : $t("page.content.withdrawApplication")
                    }}</span
                  >
                  <div class="improve-info">
                    <span
                      class="improve-btn"
                      v-if="auditStatusFlag == '4' || auditStatusFlag == '0'"
                      @click="improveInfo"
                      >{{ $t("page.content.improveInfo") }}></span
                    >
                    <el-popover
                      placement="bottom"
                      :title="$t('page.content.viewReasons')"
                      width="200"
                      v-if="auditStatusFlag == '2'"
                      trigger="click"
                      :content="auditOpinionVal"
                    >
                      <el-button
                        slot="reference"
                        type="text"
                        v-if="auditStatusFlag == '2'"
                        @click="viewReasons"
                        >{{ $t("page.content.viewReasons") }} |
                      </el-button>
                    </el-popover>
                    <span
                      class="improve-btn"
                      v-if="auditStatusFlag == '2'"
                      @click="improveInfo"
                      >{{ $t("page.content.changeInfo") }}></span
                    >
                  </div>
                </div>
              </div>
              <!-- 英文版 -->
              <div v-else class="container-text-en">
                <span
                  class="tip"
                  v-if="
                    auditStatusFlag == '1' ||
                      auditStatusFlag == '2' ||
                      auditStatusFlag == '0' ||
                      auditStatusFlag == '4'
                  "
                  >{{ $t("page.retrievePassword.confirmHint") + "：" }}</span
                >
                <div class="container">
                  <div class="notification">
                    <span v-if="auditStatusFlag == '1'">
                      {{
                        languagezh_cn
                          ? "您的注册申请正在由" +
                            puCompanyName +
                            "审批中，请耐心等待！"
                          : " Your registration application is currently being approved by " +
                            puCompanyName +
                            " Please be patient!"
                      }}
                    </span>

                    <span
                      v-if="auditStatusFlag == '4' || auditStatusFlag == '0'"
                      >{{ $t("page.retrievePassword.confirmTitle8") }}</span
                    >
                    <span v-if="auditStatusFlag == '2'">{{
                      $t("page.retrievePassword.confirmTitle9")
                    }}</span>
                  </div>
                </div>
                <div
                  class="improve-info"
                  v-if="
                    auditStatusFlag == '2' ||
                      auditStatusFlag == '4' ||
                      auditStatusFlag == '0'
                  "
                >
                  <span
                    class="improve-btn"
                    v-if="auditStatusFlag == '4' || auditStatusFlag == '0'"
                    @click="improveInfo"
                    >{{ $t("page.content.improveInfo") }}></span
                  >
                  <el-popover
                    placement="bottom"
                    :title="$t('page.content.viewReasons') + '：'"
                    width="200"
                    v-if="auditStatusFlag == '2'"
                    trigger="click"
                    :content="auditOpinionVal"
                  >
                    <el-button
                      slot="reference"
                      type="text"
                      v-if="auditStatusFlag == '2'"
                      @click="viewReasons"
                      >{{ $t("page.content.viewReasons") }} |
                    </el-button>
                  </el-popover>
                  <span
                    class="improve-btn"
                    v-if="auditStatusFlag == '2'"
                    @click="improveInfo"
                    >{{ $t("page.content.changeInfo") }}></span
                  >
                </div>
                <div class="btn">
                  <span
                    class="withdraw-btn"
                    v-if="auditStatusFlag == '1'"
                    @click="withdraw"
                  >
                    {{
                      languagezh_cn
                        ? "撤回注册申请"
                        : $t("page.content.withdrawApplication")
                    }}</span
                  >
                </div>
              </div>
            </div>
            <div v-if="auditTypeFlag == '2' && auditStatusFlag == '1'">
              <div class="container-text">
                <span class="tip">{{
                  $t("page.retrievePassword.confirmHint") + "："
                }}</span>
                <div class="container">
                  <div class="notification">
                    <span>
                      {{
                        languagezh_cn
                          ? "您的注册变更申请正在由" +
                            puCompanyName +
                            "审批中，请耐心等待！"
                          : " Your registration change application is being approved " +
                            puCompanyName +
                            " Please be patient!"
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="auditTypeFlag == '3' && auditStatusFlag == '1'">
              <div class="container-text">
                <span class="tip">{{
                  $t("page.retrievePassword.confirmHint") + "："
                }}</span>
                <div class="container">
                  <div class="notification">
                    <span>
                      {{
                        languagezh_cn
                          ? "您的合作意向申请正在由" +
                            puCompanyName +
                            "审批中，请耐心等待！"
                          : " Your application for cooperation intention is being approved " +
                            puCompanyName +
                            " Please be patient!"
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </template>
        <template v-else>
          <div
            :class="[
              'user-type-welcome',
              languagezh_cn ? '' : 'user-type-welcome-en'
            ]"
            style="margin-bottom: 10px;display: inline-block; cursor: pointer;"
            @click="handleLogin"
          >
            <div class="denglu">
              <!-- {{ $t("page.content.welcomeToBack") }} -->
              {{ $t("page.content.denglu") }}
            </div>
          </div>
          <div
            :class="[
              'user-type-welcome',
              languagezh_cn ? '' : 'user-type-welcome-en'
            ]"
            @click="handlezhuce"
            style="display: inline-block; margin-left: 30px; margin-bottom: 10px;cursor: pointer;"
          >
            <div class="zhuce">
              <!-- {{ $t("page.content.welcomeToBack") }} -->
              {{ $t("page.content.zhuce") }}
            </div>
          </div>
          <!-- <a class="user-type-link" @click="handleLogin"
            >{{ $t("page.content.loginText") }}></a
          > -->
        </template>
      </div>
    </div>
    <div class="ccui-clearfix">
      <div style="height: 40px;">
        <a @click="handleHelp(0)">
          <img
            class="fl help-center-img"
            :src="
              languagezh_cn
                ? require('@/basa/assets/images/supplier-zh.png')
                : require('@/basa/assets/images/supplier-en.png')
            "
            style="height: 30px;"
          />
        </a>
      </div>
      <div style="height: 40px;">
        <a @click="handleHelp(1)">
          <img
            class="fl help-center-img"
            :src="
              languagezh_cn
                ? require('@/basa/assets/images/FAQ-zh.png')
                : require('@/basa/assets/images/FAQ-en.png')
            "
            style="height: 30px;"
          />
        </a>
      </div>

      <!-- 取回密码 -->
      <!-- <div v-if="false"> -->
      <div v-if="loginInfo.mobile" class="pass-content">
        <a @click="handleHelp(2)" class="retrieve">
          <!--  :src="imgData[1] ? imgData[1].coverUrl : ''" -->
          <img
            class="fl retrieve-img"
            :src="
              languagezh_cn
                ? require('@/basa/assets/images/retrievePass-zh.png')
                : require('@/basa/assets/images/retrievePass-en.png')
            "
            style="height: 30px;"
          />
        </a>
        <a @click="handleExitPass(3)" class="change">
          <img
            class="fl change-img"
            :src="
              languagezh_cn
                ? require('@/basa/assets/images/changePass-zh.png')
                : require('@/basa/assets/images/changePass-en.png')
            "
            style="height: 30px;"
          />
        </a>
      </div>
      <div v-else class="pass-content">
        <a @click="handleHelp(2)" class="retrieve">
          <!--  :src="imgData[1] ? imgData[1].coverUrl : ''" -->
          <img
            class="fl retrieve-img"
            :src="
              languagezh_cn
                ? require('@/basa/assets/images/login-retrievePass-zh.png')
                : require('@/basa/assets/images/login-retrievePass-en.png')
            "
            style="height: 30px; width: 92%"
          />
        </a>
      </div>
      <!-- </div> -->
    </div>
    <div class="user-divider"></div>
    <div class="announcements-box">
      <div class="announcements-title ccui-clearfix">
        <span class="fl"
          ><i class="icon-ccui-trumpet"></i>
          <!--          <svg-icon icon-class="trumpet" class="icon-trumpet"></svg-icon>-->
          <span class="">{{ $t("page.content.Announcements") }}</span></span
        >
        <el-link
          :underline="false"
          type="info"
          class="fr color-1"
          @click="handleViewAll()"
          >{{ $t("page.content.MoreAndMore") }} ></el-link
        >
      </div>
      <ul class="announcements-ul">
        <template v-for="(item, index) in pageData">
          <li :key="index" class="ellipsis announcements-ul-li">
            <a @click="handleOp(item)" class="ellipsis" :title="item.title">{{
              item.title
            }}</a>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import {
  queryPublishedNoticeList,
  updateHits,
  querySupToDoItemsQuantity,
  getSupInfoByLoginInfo,
  qryApprovalStatus,
  returnRegisterBySup
} from "@/app/shop/api/shopping";
import { getArgs } from "@/basa/utils";
import Cookies from "js-cookie";
export default {
  name: "showUser",
  props: {
    imgData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      baseUrl: this.$addUrlPerFix(process.env.VUE_APP_BASE_URL),
      pageData: [],
      todoTotal: "",
      auditTypeFlag: "",
      auditStatusFlag: "",
      puCompanyName: "",
      supAuditId: "",
      supinfoid: "",
      auditOpinionVal: "",
      isOverseas: 0
    };
  },
  activated() {
    if (Cookies.get("access_token")) {
      this.getStatus();
    }
    this.init();
  },
  deactivated() {},
  methods: {
    getStatus() {
      if (!JSON.parse(localStorage.getItem("userInfo"))) {
        return false;
      }
      qryApprovalStatus({
        loginId: JSON.parse(localStorage.getItem("userInfo")).loginId
      }).then(res => {
        if (res.data.code === "0") {
          this.auditTypeFlag = res.data.data.auditType;
          this.auditStatusFlag = res.data.data.auditStatus;
          this.puCompanyName = res.data.data.puCompanyName;
          this.supAuditId = res.data.data.supAuditId;
          this.supinfoid = res.data.data.supinfoid
            ? res.data.data.supinfoid
            : res.data.data.tempSupinfoId;
          this.auditOpinionVal = res.data.data.auditOpinion;
          this.isOverseas = res.data.data.isOverseas;
        }
      });
    },
    viewReasons() {},
    improveInfo() {
      if (this.baseUrl.indexOf("dev01") != -1) {
        if (this.isOverseas == 1) {
          window.location.href =
            "https://dev01-sra.iccec.cn/regView/foreignSupRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        } else {
          window.location.href =
            "https://dev01-sra.iccec.cn/regView/supRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        }
      } else if (this.baseUrl.indexOf("test01") != -1) {
        if (this.isOverseas == 1) {
          window.location.href =
            "https://test01-sra.iccec.cn/regView/foreignSupRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        } else {
          window.location.href =
            "https://test01-sra.iccec.cn/regView/supRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        }
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        if (this.isOverseas == 1) {
          window.location.href =
            "https://uat01-sra.iccec.cn/regView/foreignSupRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        } else {
          window.location.href =
            "https://uat01-sra.iccec.cn/regView/supRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        }
      } else {
        if (this.isOverseas == 1) {
          window.location.href =
            "https://sra.iccec.cn/regView/foreignSupRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        } else {
          window.location.href =
            "https://sra.iccec.cn/regView/supRegDetail?supInfoApplyId=" +
            this.supinfoid +
            "&tempOrFormalFlag=0&supAuditId=" +
            this.supAuditId;
        }
      }
    },
    withdraw() {
      returnRegisterBySup({
        loginId: JSON.parse(localStorage.getItem("userInfo")).loginId
      }).then(res => {
        if (res.data.code === "0") {
          this.$confirm(
            this.$t("page.retrievePassword.confirmTitle7"),
            this.$t("page.retrievePassword.confirmHint"),
            {
              confirmButtonText: this.$t("page.retrievePassword.ascertain"),
              showCancelButton: false,
              type: "success"
            }
          );
          this.getStatus();
        }
      });
    },
    handleExitPass() {
      this.$router.push({
        path: "/editPassword",
        // path: "/editPassword",
        query: {
          // name: this.name
        }
      });
    },
    init() {
      queryPublishedNoticeList({
        pageNo: 1,
        pageSize: 5,
        module: 1,
        pageState: 2,
        textType: 1,
        appId: 100123
      }).then(res => {
        if (res.data.code === "0") {
          // this.pageData = res.data.data.rows.filter(item => {
          //   return item.textType == 1;
          // });
          this.pageData = res.data.data.rows;
        }
      });

      if (Cookies.get("access_token") && localStorage.appToken) {
        let loginId = JSON.parse(localStorage.getItem("userInfo")).loginId;
        getSupInfoByLoginInfo({
          loginId: loginId,
          agentId: this.$router.history.current.query.a,
          supCode: getArgs("SUPCODE")
        }).then(res => {
          this.getTodoTotal(res.data.data);
        });
      }
    },
    getTodoTotal(data) {
      let param = {
        supCodeList: [data.supCode],
        supCode: data.supCode
      };
      Object.assign(param, { agentId: this.$router.history.current.query.a });
      querySupToDoItemsQuantity(param).then(res => {
        let v = res.data.data;
        this.todoTotal =
          v.supplement +
          v.quotation +
          v.negotiation +
          v.bidBiding +
          v.bid +
          v.prequalification +
          v.answerQuestions +
          v.bidEvaluationClarification +
          v.sellingBid;
      });
    },
    handleHelp(index) {
      if (index == 2) {
        // window.open(
        //   `${this.$addUrlPerFix(process.env.VUE_APP_BASE_URL)}/retrievePassword`
        // );
        this.$router.push({
          path: "/retrievePassword",
          // path: "/editPassword",
          query: {
            // name: this.name
          }
        });
      } else {
        let item;
        if (index == 0) {
          this.imgData.forEach((obj, i) => {
            if (obj.otherUrl.indexOf("operationManual") != -1) {
              item = this.imgData[i];
            }
          });
        } else if (index == 1) {
          this.imgData.forEach((obj, i) => {
            if (obj.otherUrl.indexOf("question") != -1) {
              item = this.imgData[i];
            }
          });
        } else {
          item = this.imgData[index] ? this.imgData[index] : {};
        }
        if (item.otherUrl) {
          //点击量
          updateHits({
            publicityContentId: item.publicityContentId
          });
          window.open(item.otherUrl, "_blank");
        }
      }
    },
    //更多 >
    handleViewAll() {
      // let url = this.$router.resolve({
      //   path: "/announcementsList"
      // });
      // window.open(url.href, "_blank");

      let url = "/announcementsList?textType=1";
      window.open(window.location.origin + url, "_blank");
    },
    goTo() {
      window.open(
        `${this.$addUrlPerFix(process.env.VUE_APP_CRMA_URL)}/bid/homePage?a=` +
          sessionStorage.getItem("param_a")
      );
    },
    handleOp(row) {
      // let url = this.$router.resolve({
      //   path: "/announcementDetail",
      //   query: {
      //     id: row.noticeInfoId,
      //     type: this.type
      //   }
      // });
      // window.open(url.href, "_blank");

      let params = ["id=" + row.noticeInfoId];
      let url = "/announcementDetail?" + params.join("&");
      window.open(window.location.origin + url, "_blank");
    },
    //退出
    handleExit() {
      sessionStorage.clear();
      localStorage.clear();
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      // window.location.href = "/login";

      /*window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(
          this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) + "/login"
        );*/
      window.location.href =
        this.$addUrlPerFix("mla.iccec.cn/apis/mla/users/signup/doLogout") +
        "?ACCESS_TOKEN=" +
        Cookies.get("access_token") +
        "&redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    //登录
    handleLogin() {
      // window.location.href = "/login";
      // if (window.location.host == "sp.iccec.cn") {
      //   window.location.href = "http://ec.ccccltd.cn";
      // } else {
      // window.location.href =
      //   this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
      //   "?redirectUrl=" +
      //   this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
      // }

      if (this.baseUrl.indexOf("dev01") != -1) {
        window.location.href =
          "https://dev01-mla.iccec.cn/login?redirectUrl=https%3A%2F%2Ftest01-sp.iccec.cn%2F&utype=2";
      } else if (this.baseUrl.indexOf("test01") != -1) {
        window.location.href =
          "https://test01-mla.iccec.cn/login?redirectUrl=https%3A%2F%2Ftest01-sp.iccec.cn%2F&utype=2";
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        window.location.href =
          "https://uat01-mla.iccec.cn/login?redirectUrl=https%3A%2F%2Fuat01-sp.iccec.cn%2F&utype=2";
      } else {
        window.location.href =
          "https://mla.iccec.cn/login?redirectUrl=https%3A%2F%2Fsp.iccec.cn%2F&utype=2";
      }
    },
    // 注册
    handlezhuce() {
      if (this.baseUrl.indexOf("dev01") != -1) {
        window.location.href = "https://dev01-sra.iccec.cn/maReady01";
      } else if (this.baseUrl.indexOf("test01") != -1) {
        window.location.href = "https://test01-sra.iccec.cn/maReady01";
      } else if (this.baseUrl.indexOf("uat01") != -1) {
        window.location.href = "https://uat01-sra.iccec.cn/maReady01";
      } else {
        window.location.href = "https://sra.iccec.cn/maReady01";
      }
    }
  },
  computed: {
    languagezh_cn() {
      return (Cookies.get("language") || "zh-cn") === "zh-cn";
    },
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
    headLogo() {
      if (this.loginInfo.iConLink) {
        return this.loginInfo.iConLink;
      } else {
        return require("@/basa/assets/images/headLogo.png");
      }
    },
    logoClass() {
      if (this.loginInfo.name) {
        return "user-head_53 mr15";
      } else {
        return "user-head_52 mr16";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.denglu {
  width: 102px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #6291f7;
  color: #fff;
  border-radius: 3px;
  font-size: 15px;
}

.zhuce {
  width: 102px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  background: #f08b52;
  color: #fff;
  border-radius: 3px;
  font-size: 15px;
}
/deep/ .el-popover__title {
  font-size: 13px !important;
}
.pass-content {
  display: flex;
  margin-bottom: 10px;
  .retrieve {
    width: 100%;
    .retrieve-img {
      margin-left: 10px;
    }
  }
  .change {
    width: 100%;
    .change-img {
    }
  }
}
.container-text-en {
  margin-bottom: 10px;
  display: flex;
  position: relative;
  height: 40px;
  width: 236px;
  justify-content: space-between;
  .tip {
    color: rgb(255, 57, 36);
    width: 70px;
    position: absolute;
  }
  .container {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 27px;
    position: relative;
    // background: #0089ef;
  }
  .improve-info {
    font-size: 13px;
    color: #0089ef;
    // margin-left: 9px;
    cursor: pointer;
    display: flex;
    position: absolute;
    left: 0;
    top: 20px;
    /deep/.el-button--text {
      font-size: 13px !important;
    }
    .improve-btn {
      display: inline-block;
      width: 140px;
      margin-left: 5px;
    }
  }

  .notification {
    // color: #0089ef;
    display: inline-block;
    animation: scroll-left 15s linear infinite;
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .btn {
    font-size: 13px;
    color: #0089ef;
    // margin-left: 9px;
    cursor: pointer;
    .withdraw-btn {
      display: inline-block;
      width: 59px;
      margin-left: 5px;
    }

    /deep/ .el-button {
      padding: 0px !important;
      width: 63px;
      margin-left: 3px;
    }
  }
}
.container-text {
  margin-bottom: 10px;
  display: flex;
  position: relative;
  height: 20px;
  width: 236px;
  justify-content: space-between;
  .tip {
    color: rgb(255, 57, 36);
    width: 70px;
    position: absolute;
  }
  .container {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    margin-left: 35px;
    // background: #0089ef;
  }

  .notification {
    // color: #0089ef;
    display: inline-block;
    animation: scroll-left 10s linear infinite;
  }

  @keyframes scroll-left {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-100%);
    }
  }
  .btn {
    font-size: 13px;
    color: #0089ef;
    // margin-left: 9px;
    cursor: pointer;
    .withdraw-btn {
      display: inline-block;
      width: 80px;
      margin-left: 5px;
    }
    /deep/ .el-button {
      padding: 0px !important;
      width: 63px;
      margin-left: 3px;
    }
    .improve-info {
      display: flex;
      .improve-btn {
        display: inline-block;
        width: 62px;
        margin-left: 5px;
      }
    }
  }
}
/deep/ .el-button {
  padding: 0px !important;
}
.ret-pass {
  width: 240px;
  height: 40px;
  margin: 0 10px 10px;
  // background-image: url('../../../config/images/ret-pass') ;
  background: #0089ef;
}
.show-user {
  width: 260px;
  height: 370px;
  background: #ffffff;
  .user {
    margin: 15px 14px 0px 12px;
    .user-head_52 {
      width: 52px;
      height: 52px;
    }
    .user-head_53 {
      width: 53px;
      height: 53px;
    }
    .user-type-welcome {
      line-height: 28px;
      font-family: PingFang-SC-Medium;
      font-size: 20px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      max-width: 170px;
    }
    .Exit-EN {
      .edit-pass {
        display: inline-block;
        text-align: right;
        margin-right: 8px;
        color: #999;
        &:hover {
          color: #0089ef;
        }
      }
      .edit-exit {
        display: inline-block;
        color: #999;
        &:hover {
          color: #0089ef;
        }
      }
    }
    .user-type-welcome-en {
      font-size: 19px;
    }
    .font-en {
      font-size: 13px;
    }
    .user-type-link {
      line-height: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-size: 13px;
      color: #4a4a4a;
      letter-spacing: 0;
      font-weight: 400;
      margin-top: 4px;
      display: block;
      &:hover {
        color: #0089ef;
      }
    }
    .user-type-log-out {
      // display: flex;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 1px;
      cursor: pointer;
      width: 236px;
      height: 30px;
      .edit-pass {
        text-align: right;
        margin-right: 20px;
        &:hover {
          color: #0089ef;
        }
      }
      .edit-exit {
        &:hover {
          color: #0089ef;
        }
      }
      .impro-info {
        &:hover {
          color: #0089ef;
        }
      }
      span {
        float: right;
      }
      .fr {
        margin-right: 20px;
        color: #0089ef;
        float: left;
      }
      // &:hover {
      //   color: #0089ef;
      // }
    }
    .user-type-log-out-en {
      // display: flex;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
      margin-top: 1px;
      position: relative;
      cursor: pointer;
      // width: 236px;
      height: 30px;
      .edit-pass {
        text-align: right;
        margin-right: 20px;
        &:hover {
          color: #0089ef;
        }
      }
      .edit-exit {
        &:hover {
          color: #0089ef;
        }
      }
      .impro-info {
        &:hover {
          color: #0089ef;
        }
      }
      span {
        // float: right;
        position: absolute;
        right: 0;
      }
      .fr {
        margin-right: 20px;
        color: #0089ef;
        float: left;
      }
      // &:hover {
      //   color: #0089ef;
      // }
    }
  }
}

.icon-trumpet {
  width: 15.02px;
  height: 14px;
  padding-right: 7px;
}
.help-center-img {
  margin: 0 10px 10px;
}
</style>
